import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import media from 'constants/styles/media';
import { Header } from 'components/header';
import { BodyText } from 'components/typography/bodyText';
import { SECTION_IDS } from 'constants/index';
import { Section } from 'components/layout/Section';
import { useStaticQuery, graphql } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import { ABOUT_US_TEAM } from './constants/aboutUsTeam';
import { TeamMemberCard } from './components/team-member-card';

const SWrapper = styled.div`
    text-align: left;
    align-self: flex-start;
    margin-bottom: 36px;
    max-width: 632px;
`;

const SGrid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 36px;

    @media (max-width: ${media.tablet}) {
        grid-template-columns: 1fr;
        gap: 24px;
    }
`;

export const AboutUsSection = () => {
    const { t } = useTranslation();

    const { icons } = useStaticQuery(graphql`
        query team {
            icons: allFile(
                filter: { relativeDirectory: { eq: "team" } }
                sort: { fields: relativePath, order: ASC }
            ) {
                nodes {
                    id
                    childImageSharp {
                        gatsbyImageData(
                            placeholder: BLURRED
                            quality: 95
                            formats: [AUTO, WEBP, AVIF]
                            layout: FULL_WIDTH
                        )
                    }
                }
            }
        }
    `);

    const images = (icons?.nodes ?? [])
        .map(
            (node: { childImageSharp?: { gatsbyImageData?: IGatsbyImageData } }) =>
                node.childImageSharp?.gatsbyImageData,
        )
        .filter(Boolean) as IGatsbyImageData[];

    return (
        <Section id={SECTION_IDS.ABOUT_US}>
            <SWrapper>
                <Header text={t('about-us.header')} />
                <BodyText>{t('about-us.description')}</BodyText>
            </SWrapper>

            <SGrid>
                {ABOUT_US_TEAM.map((m) => {
                    const image = images[m.imageIndex];
                    if (!image) {
                        return null;
                    }
                    return (
                        <TeamMemberCard
                            key={m.nameKey}
                            image={image}
                            alt={t('about-us.team.imageAlt')}
                            name={t(m.nameKey)}
                            role={t(m.roleKey)}
                        />
                    );
                })}
            </SGrid>
        </Section>
    );
};
